import { MediumProps } from '@mf-types/remote/compiled-types/components/ShareableProfile/types/types';
import { useCallback, useEffect, useRef, useState } from 'react';
import { MediaFileType } from 'shared/enums/MediaFileType';
import {
  IRepresentativeSingleProfileHiddenMedia,
  IRepresentativeSingleProfileMedia,
} from 'shared/interfaces/IRepresentativesEditProfile';

type UseEditProfileMediaGallery = {
  hidden_media: IRepresentativeSingleProfileHiddenMedia[];
  file_type: MediaFileType;
};

export const useEditProfileMediaGallery = ({ hidden_media, file_type }: UseEditProfileMediaGallery) => {
  const [open, setOpen] = useState<boolean>(false);
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const attachedItemRef = useRef<IRepresentativeSingleProfileMedia[]>([]);

  const hidden_image_converted: MediumProps[] =
    hidden_media?.length > 0
      ? hidden_media?.map((hidden) => ({
          id: hidden.id,
          file_type: file_type,
          file_name: hidden.file_name,
          file_size: 0,
          file_width: 0,
          file_height: 0,
          tag_list: [],
          attachment: hidden.attachment_url,
          attachment_url: hidden.attachment_url,
          modified_attachment: hidden.modified_attachment_url,
          modified_attachment_url: hidden.modified_attachment_url,
          cropped_attachment: hidden.cropped_attachment_url,
          cropped_attachment_url: hidden.cropped_attachment_url,
          visible: false,
        }))
      : [];
  const attached_image_converted: MediumProps[] =
    attachedItemRef.current?.length > 0
      ? attachedItemRef.current?.map((attached) => ({
          id: attached.medium.id,
          file_type: file_type,
          file_name: attached.medium.file_name,
          file_size: 0,
          file_width: 0,
          file_height: 0,
          tag_list: [],
          attachment: attached.medium.attachment_url,
          attachment_url: attached.medium.attachment_url,
          modified_attachment: attached.medium.modified_attachment_url,
          modified_attachment_url: attached.medium.modified_attachment_url,
          cropped_attachment: attached.medium.cropped_attachment_url,
          cropped_attachment_url: attached.medium.cropped_attachment_url,
          visible: false,
        }))
      : [];

  const handleOpen = useCallback(
    (index: number, isHidden?: boolean) => {
      setSelectedIndex(isHidden ? attachedItemRef?.current.length + index : index);
      setOpen(true);
    },
    [attachedItemRef.current],
  );

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const mappedData = [...attached_image_converted, ...hidden_image_converted];

  return { open, selectedIndex, handleOpen, handleClose, mappedData, attachedItemRef };
};
